import React, { Component } from 'react';

import { SkeletonBodyText, Layout, BlockStack } from '@shopify/polaris';

class LoadingPageForms extends Component{

    constructor(props) {
        super(props);
        
        this.state = {
        };
      }

    
  render() {
    return (
      <div style={{ padding:'1.5rem 0' }}>
        <Layout>
          <Layout.Section>
              <BlockStack gap={800}>
                  <SkeletonBodyText/>
                  <SkeletonBodyText/>
                  <SkeletonBodyText/>
                  <SkeletonBodyText/>
                  <SkeletonBodyText/>
                  <SkeletonBodyText/>
                  <SkeletonBodyText/>
                  <SkeletonBodyText/>
                  <SkeletonBodyText/>
                  <SkeletonBodyText/>
                  <SkeletonBodyText/>
                  <SkeletonBodyText/>
                  <SkeletonBodyText/>
              </BlockStack>
          </Layout.Section>
        </Layout>
      </div>
    );
  }
  
  handleChange = () => {
    this.setState(({enabled}) => {
        return {enabled: !enabled};
    });
  };
}

export default LoadingPageForms;